import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { BrokerTopic } from './broker-model';
import { BrokerTopics } from './broker-topics.enum';

@Injectable({
  providedIn: 'root',
})
export class MessageBrokerService {
  private topics = new Array<BrokerTopic>();

  constructor() {}

  publish(topic: BrokerTopics, data: any) {
    let targetTopic = this.topics.find((t) => t.topicName === topic);
    if (!targetTopic) {
      targetTopic = this.createTopic(topic);
    }

    targetTopic.subject.next(data);
    return true;
  }

  subscribe(topic: BrokerTopics) {
    let targetTopic = this.topics.find((t) => t.topicName === topic);
    if (!targetTopic) {
      targetTopic = this.createTopic(topic);
    }

    return targetTopic.subject.asObservable();
  }

  private createTopic(topicName: BrokerTopics) {
    const topicItem = {
      topicName,
      subject: new Subject<any>(),
    };
    this.topics.push(topicItem);
    return topicItem;
  }
}
